// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationEnterNamePath = 'M61.99 67.566c1.352.233 2.728.346 4.11.334 4.98 0 10-1.473 14.021-4.178L83.7 91H15.8L11 54h33.518a24.5 24.5 0 0010.765 11.304A142.548 142.548 0 0051.7 81.4l7 1.2a133.27 133.27 0 013.29-15.034zm2.1-6.842C71.064 39.868 80.847 26.452 81 26.3l-5.6-4.1c-.53.683-10.667 14.479-17.977 36.198A17 17 0 0150 48.7a11.2 11.2 0 01-.1-5.8l9.4 3.8-2.7-14.6a3.1 3.1 0 01.3-2.3A41.601 41.601 0 0168.8 16a39.701 39.701 0 0118.8-7.7 63.71 63.71 0 012.3 7.3c1 4.6.7 13.1-1.5 18.4a3.6 3.6 0 01-1.1 1.4l-13.1 9.8 8.5 2.8-2.7 6.1c-2.999 4.723-9.763 7.31-15.91 6.624zM92.2 43.7l-5.852 13.238L91.7 98H9.6L3 47h39.571A17.7 17.7 0 0145 36.6l1.6-2.5 3.5 1.4-.4-2.1a10.6 10.6 0 01.9-6.8 48 48 0 0114-16.2A48.8 48.8 0 0189.4 1l2.3-.2 1.1 2.1a53.599 53.599 0 013.9 11.2c1.3 5.7 1 15.7-1.8 22.6a10.2 10.2 0 01-3.4 4.3l-2.3 1.7 3 1z';
var IllustrationEnterName = baseIllustration('IllustrationEnterName', {
  getPath: () => IllustrationEnterNamePath
}, 'ColoredIllustrationEnterName');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationEnterName;
//# sourceMappingURL=index.js.map